import { Plus } from "lucide-react";
import { faqs } from "../data/content";

/**
 * FAQ section built on native <details>/<summary> so it works without any
 * JavaScript (matches the site's SSR/progressive-enhancement approach) and is
 * accessible by default. The matching FAQPage structured data lives in
 * index.html — keep both in sync with the `faqs` data source.
 */
export function Faq(): JSX.Element {
  return (
    <section
      id="faq"
      aria-labelledby="faq-title"
      className="bg-surface-container-low py-20 sm:py-24 lg:py-28"
    >
      <div className="container-welope">
        <div className="bloom-on-scroll mx-auto max-w-3xl text-center">
          <p className="section-eyebrow">Häufige Fragen</p>
          <h2
            id="faq-title"
            className="mt-3 font-headline text-headline-xl text-primary sm:text-[44px]"
          >
            Gut zu wissen.
          </h2>
        </div>

        <div className="mx-auto mt-12 max-w-3xl space-y-3">
          {faqs.map((item, idx) => (
            <details
              key={item.question}
              className="bloom-on-scroll group rounded-xl border border-outline-variant/40 bg-surface-container-lowest px-md py-1 [&_summary::-webkit-details-marker]:hidden"
              style={{ transitionDelay: `${idx * 60}ms` }}
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-4 font-headline text-headline-md text-on-surface">
                {item.question}
                <Plus
                  className="h-5 w-5 shrink-0 text-secondary transition-transform duration-200 group-open:rotate-45"
                  aria-hidden="true"
                />
              </summary>
              <p className="pb-4 pr-8 font-body text-body-md leading-[1.6] text-on-surface-variant">
                {item.answer}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
